import { Box, Button, Stack, styled, Toolbar } from '@mui/material';
import { Container } from '@mui/system';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getUrlLink } from '../features/ddjj/decJuradaSlice';
import { getImponiblesList } from '../features/imponibles/imponiblesSlice';
import { authed } from '../features/login/loginSlice';

const Wrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
}));

const Menu = styled(Stack)(({ theme }) => ({
  display: 'none',

  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    padding: '1rem 1rem .625rem 1rem',
  },
}));

const HeaderItem = styled(Button, {
  shouldForwardProp: prop => prop !== 'selected',
})<{ selected?: boolean }>(({ theme, selected = false }) => ({
  padding: '.5rem .75rem',
  borderRadius: '5px',
  fontWeight: 500,
  fontSize: '.75rem',
  letterSpacing: '.02rem',
  textDecoration: 'none',
  color: theme.palette.primary.main,
  display: 'flex',
  alignItems: 'center',
  backgroundColor: selected ? 'rgba(54, 183, 232, 0.04)' : undefined,
}));

export default function Header() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const url = useSelector(getUrlLink);
  const isLogged = useSelector(authed);
  const imponibles = useSelector(getImponiblesList);

  const haveComercio = imponibles?.some(
    imponible => imponible.tipo === 'COM'
  );

  const scrollDown = () => {
    const element = document.getElementById('Imponibles');

    if (pathname === '/') {
      element?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    } else {
      navigate('/');
      setTimeout(() => {
        const element2 = document.getElementById('Imponibles');
        element2?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }, 1500);
    }
  };

  const handleHomeClick = () => {
    navigate('/');
  };

  const handleLogInClick = () => {
    navigate('/login');
  };

  const handlePayBillClick = () => {
    navigate('/paga-tu-tasa');
  };

  const handleAutomaticDebClick = () => {
    navigate('/debito-automatico');
  };

  const handlePayFineClick = () => {
    window.location.href = 'https://juzgadodefaltas.msm.gov.ar/ords/smi/f?p=204';
  };

  const handleVoucherClick = () => {
    navigate('/boleta');
  };

  const handleQuestionsClick = () => {
    navigate('/preguntas-frecuentes');
  };

  const handleMyPaymentsClick = () => {
    navigate('/mis-pagos');
  };

  // const handleDdjjClick = () => {
  //   navigate('/declaraciones-juradas');
  // };

  const handleMethodsClick = () => {
    navigate('/medios-pagos');
  };


  const buttonText = import.meta.env.VITE_EPAGOS === 'true' ? 'Inicio' : 'Iniciar Sesión';

  return (
    <Wrapper sx={{ borderBottom: '1px solid', borderColor: '#E4E6EF' }}>
      <Toolbar sx={{ marginTop: '1.625rem' }} />
      <Container>
        {isLogged ? (
          <Menu direction="row" spacing={2}>

            <HeaderItem
              onClick={handleHomeClick}
              selected={pathname === '/'}
            >
              Inicio
            </HeaderItem>

            <HeaderItem onClick={() => scrollDown()}>
              Mis Imponibles
            </HeaderItem>

            <HeaderItem
              onClick={handleMyPaymentsClick}
              selected={pathname === '/mis-pagos'}
            >
              Mis Pagos
            </HeaderItem>

            <HeaderItem
              onClick={handlePayFineClick}
              selected={window.location.href === 'https://juzgadodefaltas.msm.gov.ar/ords/smi/f?p=204'}
            >
              Pagá tu multa
            </HeaderItem>

            <HeaderItem
              onClick={handleAutomaticDebClick}
              selected={pathname === '/debito-automatico'}
            >
              Débito Automático
            </HeaderItem>

            {
              haveComercio
                ? <HeaderItem onClick={() => window.open(url)}>
                  Declaraciones Juradas
                </HeaderItem>
                : null
            }

            <HeaderItem
              onClick={handleQuestionsClick}
              selected={pathname === '/preguntas-frecuentes'}
            >
              Preguntas Frecuentes
            </HeaderItem>


            {/* <HeaderItem
              onClick={handleMethodsClick}
              selected={pathname === '/medios-pagos'}
            >
              Medios de pago adheridos
            </HeaderItem> */}

            {/* 
            <HeaderItem
              onClick={handleDdjjClick}
              selected={pathname === '/declaraciones-juradas'}
            >
              Declaraciones Juradas
            </HeaderItem> */}
          </Menu>
        ) : (
          <Menu direction="row" spacing={2}>

            <HeaderItem onClick={handleLogInClick}>
              {buttonText}
            </HeaderItem>

            <HeaderItem
              onClick={handlePayBillClick}
              selected={pathname === '/paga-tu-tasa'}
            >
              Pagá tu tasa
            </HeaderItem>

            <HeaderItem
              sx={{ display: import.meta.env.VITE_EPAGOS === 'true' ? 'none' : 'flex' }}
              onClick={handlePayFineClick}
              selected={pathname === 'https://juzgadodefaltas.msm.gov.ar/ords/smi/f?p=204'}
            >
              Pagá tu multa
            </HeaderItem>

            <HeaderItem
              onClick={handleAutomaticDebClick}
              selected={pathname === '/debito-automatico'}
            >
              Débito Automático
            </HeaderItem>

            <HeaderItem
              onClick={handleVoucherClick}
              selected={pathname === '/boleta'}
            >
              Boleta por mail
            </HeaderItem>

            <HeaderItem
              onClick={handleQuestionsClick}
              selected={pathname === '/preguntas-frecuentes'}
            >
              Preguntas Frecuentes
            </HeaderItem>
          </Menu>
        )}
      </Container>
    </Wrapper>
  );
}
